import { useInView } from "@/hooks/useInView";
import { Quote } from "lucide-react";

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.neuronest.send&pcampaignid=web_share";

const TESTIMONIALS = [
  {
    quote:
      "NeuroNest feels like the first app that was actually designed for how my brain works.",
    author: "Future user testimonial",
  },
  {
    quote: "No guilt, no pressure, no judgment. Just tools that help.",
    author: "Future user testimonial",
  },
];

export default function TestimonialCTA() {
  const [testRef, testInView] = useInView();
  const [ctaRef, ctaInView] = useInView();

  return (
    <>
      {/* Testimonials */}
      <section
        data-testid="testimonials-section"
        className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-white relative"
      >
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#E7E9EC] to-transparent" />
        <div ref={testRef} className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {TESTIMONIALS.map((t, i) => (
              <div
                key={i}
                data-testid={`testimonial-card-${i}`}
                className={`bg-[#F8F9FB] rounded-3xl p-8 relative transition-all duration-700 ${
                  testInView
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-6"
                }`}
                style={{ transitionDelay: `${i * 150}ms` }}
              >
                <Quote
                  size={28}
                  className="text-brand-purple/30 mb-4"
                  strokeWidth={1.5}
                />
                <blockquote className="text-[#2F3A56] text-base md:text-lg leading-relaxed mb-4 font-medium italic">
                  "{t.quote}"
                </blockquote>
                <p className="text-sm text-[#8B95A5]">— {t.author}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section
        id="cta"
        data-testid="cta-section"
        className="py-20 md:py-32 px-6 md:px-12 lg:px-20 relative overflow-hidden"
      >
        {/* Decorative blobs */}
        <div className="absolute -top-20 -left-20 w-[400px] h-[400px] bg-brand-teal rounded-full opacity-[0.06] blur-[100px] pointer-events-none" />
        <div className="absolute -bottom-20 -right-20 w-[350px] h-[350px] bg-brand-purple rounded-full opacity-[0.06] blur-[80px] pointer-events-none" />

        <div
          ref={ctaRef}
          className={`max-w-3xl mx-auto text-center relative z-10 transition-all duration-700 ${
            ctaInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <h2
            data-testid="cta-headline"
            className="font-heading text-3xl md:text-5xl font-bold text-[#2F3A56] leading-tight mb-6"
          >
            Your pace. Your space. Your way.
          </h2>
          <p className="text-base md:text-lg text-[#5A6376] leading-relaxed mb-10 max-w-xl mx-auto">
            Ready to explore a calmer way to navigate your day?
          </p>
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-download-button"
          >
            <img
              src={`${process.env.PUBLIC_URL}/google-play-badge.png`}
              alt="Get it on Google Play"
              className="h-16 mx-auto"
            />
          </a>
          <p className="mt-6 text-sm text-[#8B95A5]">
            Available on Android. iOS coming soon.
          </p>
        </div>
      </section>
    </>
  );
}
